export default {
  path: '/kanban-boards',
  component: () => import(/* webpackChunkName: "kanban-boards" */ './KanbanBoards'),
  meta: {
    requiresAuth: true
  }
}
